import type { WebPageSection } from '@/lib/api'
import { ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { parseHtmlString } from '@/utils/helpers/html'

interface MemberCountriesProps {
  className?: string,
  data: WebPageSection
}

const MemberCountries = ({ className, data }: MemberCountriesProps) => {
  const navigate = useNavigate()

  const handleViewAll = () => {
    navigate('/about/member-countries')
  }

  return (
    <section className={`py-16 ${className}`}>
      <div className="max-w-[1440px] px-4 sm:px-6 lg:px-28  mx-auto">
        <div className="bg-deepGold-100 px-8 py-8 text-white">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 items-start">
            <div className="lg:col-span-1">
              <h2 className="text-3xl font-normal font-pt-serif leading-loose">
                {data?.title ?? "Member Countries"}
              </h2>
            </div>
            
            <div className="lg:col-span-3 space-y-4">
              <p className="font-normal font-pt-serif" dangerouslySetInnerHTML={parseHtmlString(data?.description ?? "AfSA's membership has expanded from its initial formation to include all 55 Member States of the African Union. All AU Member States are eligible to participate in AfSA's programs and decision-making processes. States engage with AfSA in accordance with the African Space Policy and Strategy, as endorsed by the African Union.")}>
              </p>
              
          
              
              <button 
                onClick={handleViewAll}
                className="inline-flex items-center gap-2 pt-4 hover:text-gray-200 transition-colors"
              >
                <span className="text-base font-medium font-satoshi">View all</span>
                <ArrowRight className="h-6 w-6" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MemberCountries